import { HttpClient, HttpEventType, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { DirectUpload, MAX_FILE_SIZE, UploadTokenRes } from '../s3/direct-upload.model';

@Injectable({
  providedIn: 'root'
})
export class JWTService {
  constructor(private http: HttpClient) {}

  downloadWithJWT(orgUuid: string, jwt: string, fileKey: string, isThumbnail = false) {
    let params = new HttpParams();
    if (isThumbnail) params = params.append('thumbnail', 'true');

    let s3KeyWithouOrgUuid = fileKey;
    if (s3KeyWithouOrgUuid.startsWith('storage://')) {
      s3KeyWithouOrgUuid = s3KeyWithouOrgUuid.replace('storage://', '');
    }

    return this.http.get(`file/public/file/jwt/${orgUuid}/${s3KeyWithouOrgUuid}`, {
      observe: 'response',
      responseType: 'arraybuffer',
      headers: { Authorization: `Bearer ${jwt}` },
      params
    });
  }

  uploadJWTWithAVScan(file: File, jwt: string) {
    if (file.size > MAX_FILE_SIZE) {
      return throwError(`Your proposed upload exceeds ${MAX_FILE_SIZE / (1024 * 1024)}MB`);
    }
    return this._directUploadToken<UploadTokenRes>(file, jwt);
  }

  private _directUploadToken<T extends DirectUpload>(file: File | Blob, jwt: string) {
    if (file.size > MAX_FILE_SIZE) {
      return throwError(`Your proposed upload exceeds ${MAX_FILE_SIZE / (1024 * 1024)}MB`);
    }

    let params = new HttpParams();
    params = params.set('asyncAvScan', true);

    return this.http
      .put<T>(`file/public/file/jwt`, file, {
        headers: { 'x-file-size': String(file.size), Authorization: `Bearer ${jwt}` },
        observe: 'events',
        reportProgress: true,
        params: params
      })
      .pipe(
        map(event => {
          switch (event.type) {
            case HttpEventType.Sent:
              return <T>{ status: 'started', percentage: 0 };
            case HttpEventType.UploadProgress:
              return <T>{ status: 'processing', percentage: Math.round((100 * event.loaded) / event.total) };
            case HttpEventType.ResponseHeader:
            case HttpEventType.DownloadProgress:
              return <T>{ status: 'preparing', percentage: 100 };
            case HttpEventType.Response:
              return <T>{ status: 'completed', percentage: 100, ...event.body };
            default:
              return <T>{ status: 'completed', percentage: 100 };
          }
        })
      );
  }
}
